






























import Vue from "vue";
import { mapState, mapActions } from "vuex";
import {
  ProductTabFilterOptions,
  PageConfig,
  IncompleteVisitsDateFilterItems,
  getErrorMsg,
} from "@/types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import ProductTable from "../ProductTable.vue";
import CellRenderer from "../TableRenderers/IncompleteVisitsTableRenderer.vue";
import { formatDateForQuery, formatDateOnRange, dateToTime } from "@/utils";
import AlertPopup from "../AlertPopup.vue";
import InfiniteLoading from "vue-infinite-loading";

const dateOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};
export default Vue.extend({
  name: "manage-products",
  components: {
    ProductTable,
    InfiniteLoading,
    AlertPopup,
  },
  data(): { [key: string]: any } {
    return {
      pluginState: null,
      searchData: {
        searchText: "",
        option: "",
      },
      dateFilter: Object.assign(
        IncompleteVisitsDateFilterItems[0],
        {
          displayText: IncompleteVisitsDateFilterItems[0].display_name,
        },
        { start_date: null, end_date: null }
      ),
      incompleteVisitsTableColumns: [
        {
          name: "customer_details",
          display_name: "Project Details",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "visit_time",
          display_name: "Visit Time",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "reason",
          display_name: "Reason For Meeting",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "met_client",
          display_name: "Meet With Client",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
      ],
    };
  },
  provide(): any {
    return {
      actionHandler: (this as any).handleTableAction,
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
    }),
    ...mapState("appModule", {
      incompleteVisitsTableData: "incompleteVisitsDetails",
      selectedEc: "selectedEc",
    }),
  },
  methods: {
    ...mapActions("appModule", ["incompleteVisits", "updateEcVisit"]),
    updateRoute() {
      let apiQuery = {
        [(this as any).searchData.option.name]: (this as any).searchData
          .searchText,
        limit: (this as any).incompleteVisitsTableData.pageConfig.limit,
        offset: (this as any).incompleteVisitsTableData.pageConfig.offset,
        ec_id__in: (this as any).selectedEc.name,
      };
      if ((this as any).incompleteVisitsTableData.pageConfig.dateFilter) {
        apiQuery = Object.assign(
          apiQuery,
          (this as any).incompleteVisitsTableData.pageConfig.dateFilterQuery
        );
      }
      (this as any).incompleteVisitsTableData.pageConfig.query = encodeQueryParams(
        apiQuery
      );
      const routeLink =
        "/incompletevisits/" +
        JSON.stringify({
          search: (this as any).searchData,
          pageConfig: (this as any).incompleteVisitsTableData.pageConfig,
        });
      (this as any).searchHistory();
      (this as any).$router.push({
        path: routeLink,
      });
    },
    searchHistory() {
      let ctx = this;
      return (this as any)
        .incompleteVisits(
          Object.assign((this as any).incompleteVisitsTableData.pageConfig, {
            isOnMobileDevice: (this as any).isOnMobileDevice,
          })
        )
        .then((response: any) => {
          if (ctx.isOnMobileDevice && ctx.pluginState) {
            if (response.totalcount <= response.data.length) {
              ctx.pluginState.complete();
            } else {
              ctx.pluginState.loaded();
            }
          }
        });
    },
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          (this as any).incompleteVisitsTableData.pageConfig.offset =
            (this as any).incompleteVisitsTableData.pageConfig.limit *
            (data - 1);
          (this as any).incompleteVisitsTableData.pageConfig.page = data;
          (this as any).updateRoute();
          break;
        case "setPageLength":
          (this as any).incompleteVisitsTableData.pageConfig.limit = data;
          (this as any).incompleteVisitsTableData.pageConfig.page = 1;
          (this as any).incompleteVisitsTableData.pageConfig.offset = 0;
          (this as any).updateRoute();
          break;
        case "rowselect":
          (this as any).$router.push({
            path: "/search/projects",
            query: {
              pids: String(data.customer_details.project_id),
            },
          });
          break;
        case "markVisit":
          (this as any).onMarkVisit(data);
          break;
        case "meetWithClient":
          (this as any).markVisit(data);
          break;
        case "setDateFilter":
          //sets the date filter to the selected datefilter type
          (this as any).dateFilter = data;
          (this as any).dateFilter.displayText = (this as any).dateFilter.displayName;
          IncompleteVisitsDateFilterItems.forEach((filter: any) => {
            if (data.name === filter.name) {
              (this as any).dateFilter = Object.assign(filter, {
                displayText: filter.display_name,
              });
              if (filter.name === "show_all") {
                (this as any).incompleteVisitsTableData.pageConfig.dateFilter = (this as any).dateFilter;
                (this as any).incompleteVisitsTableData.pageConfig.dateFilterQuery =
                  "";
              } else {
                (this as any).incompleteVisitsTableData.pageConfig.dateFilter = (this as any).dateFilter;
                (this as any).incompleteVisitsTableData.pageConfig.dateFilterQuery = {
                  created_at__gte: dateToTime(
                    formatDateOnRange(new Date(), "from")
                  ),
                };
              }
              (this as any).updateRoute();
              if ((this as any).isOnMobileDevice) {
                (this as any).$store.commit(
                  "appModule/resetIncompleteVisits",
                  null,
                  {
                    root: true,
                  }
                );
                (this as any).incompleteVisitsTableData.pageConfig = JSON.parse(
                  JSON.stringify(PageConfig)
                );
              }
            }
          });
          break;
        case "applyDateFilter":
          //calculate the appropriate date filter when Apply Button is clicked
          (this as any).dateFilter = data;
          (this as any).dateFilter.displayText = (this as any).dateFilter.displayName;
          //when show_all is not selected then calculate the date filters
          if (
            (this as any).dateFilter.start_date &&
            (this as any).dateFilter.end_date &&
            data.name !== IncompleteVisitsDateFilterItems[0].name
          ) {
            (this as any).dateFilter.displayText =
              (this as any).dateFilter.displayText +
              " : " +
              new Date((this as any).dateFilter.start_date).toLocaleDateString(
                "en",
                dateOptions as any
              ) +
              " - " +
              new Date((this as any).dateFilter.end_date).toLocaleDateString(
                "en",
                dateOptions as any
              );
            (this as any).applyDateFilter();
            if ((this as any).isOnMobileDevice) {
              (this as any).$store.commit(
                "appModule/resetIncompleteVisits",
                null,
                {
                  root: true,
                }
              );
              (this as any).incompleteVisitsTableData.pageConfig = JSON.parse(
                JSON.stringify(PageConfig)
              );
            }
          }
          break;
      }
    },
    initManageHistory() {
      const parsedJSONData = JSON.parse(
        (this as any).$router.currentRoute.params.searchQuery
      );
      (this as any).searchData = parsedJSONData.search
        ? parsedJSONData.search
        : {};
      (this as any).incompleteVisitsTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      if (parsedJSONData.pageConfig && parsedJSONData.pageConfig.dateFilter) {
        (this as any).dateFilter = parsedJSONData.pageConfig.dateFilter;
      } else {
        (this as any).dateFilter = Object.assign(
          IncompleteVisitsDateFilterItems[0],
          {
            displayText: IncompleteVisitsDateFilterItems[0].display_name,
          }
        );
      }
    },
    handleInfiniteScroll($state: any) {
      (this as any).pluginState = $state;
      if (
        (this as any).incompleteVisitsTableData.data &&
        (this as any).incompleteVisitsTableData.data.length > 0
      ) {
        (this as any).incompleteVisitsTableData.pageConfig.offset =
          (this as any).incompleteVisitsTableData.pageConfig.limit *
          (this as any).incompleteVisitsTableData.pageConfig.page;
        (this as any).incompleteVisitsTableData.pageConfig.page += 1;
        (this as any).updateRoute();
      } else {
        (this as any).pluginState.loaded();
      }
    },
    onMarkVisit(clientData: { data: { id: number }; type: boolean }) {
      let message = "";
      if (clientData.type) {
        message = "Please confirm the client was attended";
      } else {
        message = "Please confirm the client was not attended";
      }
      (this as any).$store.commit("uiModule/addAlert", {
        title: "Meet With Client",
        id: clientData.data.id,
        completed: clientData.type,
        message: message,
      });
    },
    markVisit(clientData: { id: number; completed: boolean }) {
      (this as any).updateUserEcVisit(clientData.completed, clientData.id);
    },
    updateUserEcVisit(completed: boolean, id: number) {
      (this as any)
        .handleWithDecorationAction(() => {
          return (this as any).updateEcVisit({
            visit_id: id,
            data: {
              completed: completed,
            },
          });
        })
        .then((response: any) => {
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "success",
            message: "EC Visit updated",
          });
          (this as any).updateRoute();
        })
        .catch((err: any) => {
          (this as any).$store.commit(
            "appModule/updateUserNotificationState",
            "failed"
          );
        });
    },
    handleWithDecorationAction(asyncFunc: (...args: any) => Promise<any>) {
      return asyncFunc
        .apply(arguments)
        .then((response: any) => {
          return response;
        })
        .catch((err: any) => {
          (this as any).$store.commit("uiModule/hideLoadingModal", null, {
            root: true,
          });
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: getErrorMsg(err),
          });
          throw err;
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      (this as any).initManageHistory();
      if (!(this as any).isOnMobileDevice) {
        (this as any).searchHistory();
      }
    }
  },
  mounted() {
    (this as any).initManageHistory();
  },
});
